import React from "react";
import { NavLink, Link } from "react-router-dom";
import {
	Navbar,
	Nav,
	Container,
	NavDropdown,
	Image,
	Badge,
	Row,
	Col,
} from "react-bootstrap";
import DropDownTitle from "../common/DropDownTitle";
import CartDropdownHeader from "../cart/CartDropdownHeader";
import CartDropdownItem from "../cart/CartDropdownItem";
import Icofont from "react-icofont";
import DataService from "../../services/DataService";
import CategoriesCarousel from "./CategoriesCarousel";
import { convertLabel } from "../../helpers/labelSupportHelper";

class Header extends React.Component {
	constructor(props) {
		super(props);
		this.dataHandler = new DataService("restaurants");
		let cart = this.dataHandler.getCart(this.props.pathName);

		this.state = {
			isNavExpanded: false,
			key_name: this.props.pathName,
			cart: cart,
			configs: this.props?.configs || {},
		};
	}

	setIsNavExpanded = (isNavExpanded) => {
		this.setState({ isNavExpanded: isNavExpanded });
	};
	closeMenu = () => {
		this.setState({ isNavExpanded: false });
	};

	handleClick = (e) => {
		if (this.node.contains(e.target)) {
			// if clicked inside menu do something
		} else {
			// If clicked outside menu, close the navbar.
			this.setState({ isNavExpanded: false });
		}
	};

	toggleLanguage = () => {
		const newLanguage =
			this.props?.configs?.selectedLanguage === "en" ? "fr" : "en";
		this.props.setSelectedLanguage &&
			this.props.setSelectedLanguage(newLanguage);
	};

	componentDidMount() {
		document.addEventListener("click", this.handleClick, false);
	}

	componentWillUnmount() {
		document.removeEventListener("click", this.handleClick, false);
	}
	render() {
		return (
			<div ref={(node) => (this.node = node)}>
				<section className="section pt-1 pb-3 text-center bg-white content-mobile-head top">
					<Container>
						<Row>
							<Col
								sm={12}
								className="bg-white position-relative text-center"
							>
								<Nav.Link
									eventKey={0}
									as={NavLink}
									activeclassname="active"
									exact
									to={"/" + this.props.pathName}
								>
									{convertLabel(this.props.configs, "Home")}{" "}
									<span className="sr-only">(current)</span>
								</Nav.Link>
								{this.props?.configs?.selectedLanguage && (
									<div
										onClick={this.toggleLanguage}
										style={{
											position: "absolute",
											right: "10px",
											top: "50%",
											transform: "translateY(-50%)",
											cursor: "pointer",
											display: "inline-flex",
											alignItems: "center",
											backgroundColor: "#f8f9fa",
											border: "1px solid #dee2e6",
											borderRadius: "20px",
											padding: "3px",
											fontSize: "10px",
											fontWeight: "600",
											transition: "all 0.2s ease",
											boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
											minWidth: "50px",
											height: "26px",
										}}
										// onMouseEnter={(e) => {
										// 	e.target.style.backgroundColor =
										// 		"#e9ecef";
										// 	e.target.style.borderColor = "#adb5bd";
										// }}
										// onMouseLeave={(e) => {
										// 	e.target.style.backgroundColor =
										// 		"#f8f9fa";
										// 	e.target.style.borderColor = "#dee2e6";
										// }}
									>
										<span
											style={{
												backgroundColor:
													this.props?.configs
														?.selectedLanguage === "en"
														? "#000000"
														: "transparent",
												color:
													this.props?.configs
														?.selectedLanguage === "en"
														? "white"
														: "#6c757d",
												borderRadius: "14px",
												padding: "2px 6px",
												fontSize: "9px",
												fontWeight: "600",
												transition: "all 0.2s ease",
												minWidth: "18px",
												textAlign: "center",
											}}
										>
											EN
										</span>
										<span
											style={{
												backgroundColor:
													this.props?.configs
														?.selectedLanguage === "fr"
														? "#000000"
														: "transparent",
												color:
													this.props?.configs
														?.selectedLanguage === "fr"
														? "white"
														: "#6c757d",
												borderRadius: "14px",
												padding: "2px 6px",
												fontSize: "9px",
												fontWeight: "600",
												transition: "all 0.2s ease",
												minWidth: "18px",
												textAlign: "center",
											}}
										>
											FR
										</span>
									</div>
								)}
							</Col>

							{this.props.pathLength == 2 && (
								<Col sm={12} className="bg-white">
									<CategoriesCarousel
										categories={this.props.displayCategories}
									/>
								</Col>
							)}
						</Row>
					</Container>
				</section>
				<Navbar
					onToggle={this.setIsNavExpanded}
					expanded={this.state.isNavExpanded}
					color="light"
					expand="lg"
					className="navbar-light osahan-nav shadow-sm"
				>
					<Container>
						{/*<Navbar.Brand to="/"><Image src="/img/1.jpg" width="100px" height="100px" alt='' /><span class="badge badge-danger">online</span></Navbar.Brand>*/}

						<Navbar.Collapse id="navbarNavDropdown">
							<Nav
								activeKey={0}
								className="ml-auto"
								onSelect={this.closeMenu}
							>
								<Nav.Link
									eventKey={0}
									as={NavLink}
									activeclassname="active"
									exact
									to={"/" + this.props.pathName}
								>
									{convertLabel(this.props.configs, "Home")}{" "}
									<span className="sr-only">(current)</span>
								</Nav.Link>
								{this.props?.configs?.selectedLanguage && (
									<Nav.Link
										as="div"
										style={{
											padding: "0.3rem 0.5rem",
											display: "flex",
											alignItems: "center",
											lineHeight: "1.5",
											marginTop: "-2px",
										}}
									>
										<div
											onClick={this.toggleLanguage}
											style={{
												cursor: "pointer",
												display: "inline-flex",
												alignItems: "center",
												backgroundColor: "#f8f9fa",
												border: "1px solid #dee2e6",
												borderRadius: "20px",
												padding: "3px",
												fontSize: "10px",
												fontWeight: "600",
												transition: "all 0.2s ease",
												boxShadow:
													"0 1px 3px rgba(0,0,0,0.1)",
												minWidth: "50px",
												height: "26px",
											}}
											// onMouseEnter={(e) => {
											// 	e.target.style.backgroundColor =
											// 		"#e9ecef";
											// 	e.target.style.borderColor =
											// 		"#adb5bd";
											// }}
											// onMouseLeave={(e) => {
											// 	e.target.style.backgroundColor =
											// 		"#f8f9fa";
											// 	e.target.style.borderColor =
											// 		"#dee2e6";
											// }}
										>
											<span
												style={{
													backgroundColor:
														this.props?.configs
															?.selectedLanguage ===
														"en"
															? "#000000"
															: "transparent",
													color:
														this.props?.configs
															?.selectedLanguage ===
														"en"
															? "white"
															: "#6c757d",
													borderRadius: "14px",
													padding: "2px 6px",
													fontSize: "9px",
													fontWeight: "600",
													transition: "all 0.2s ease",
													minWidth: "18px",
													textAlign: "center",
												}}
											>
												EN
											</span>
											<span
												style={{
													backgroundColor:
														this.props?.configs
															?.selectedLanguage ===
														"fr"
															? "#000000"
															: "transparent",
													color:
														this.props?.configs
															?.selectedLanguage ===
														"fr"
															? "white"
															: "#6c757d",
													borderRadius: "14px",
													padding: "2px 6px",
													fontSize: "9px",
													fontWeight: "600",
													transition: "all 0.2s ease",
													minWidth: "18px",
													textAlign: "center",
												}}
											>
												FR
											</span>
										</div>
									</Nav.Link>
								)}
							</Nav>
						</Navbar.Collapse>
					</Container>
				</Navbar>
			</div>
		);
	}
}

export default Header;
